export interface TaxYearConfig {
  label: string;
  start: string;
  end: string;
  deadlines: {
    register: string;
    fileOnline: string;
    pay: string;
  };
}

export const TIER1_RATE = 0.45;
export const TIER2_RATE = 0.25;
export const TIER1_LIMIT = 10000;

// Returns pence, matching the convention of every other monetary field on TaxYearSummary.
export function calculateMileageAllowance(totalMiles: number): number {
  const tier1 = Math.min(totalMiles, TIER1_LIMIT) * TIER1_RATE;
  const tier2 = Math.max(totalMiles - TIER1_LIMIT, 0) * TIER2_RATE;
  return Math.round((tier1 + tier2) * 100);
}

// To support a new tax year: append one entry here each April. No other code changes needed.
// UK tax year runs 6 Apr → 5 Apr. HMRC deadlines: register by 5 Oct, file online & pay by 31 Jan.
export const TAX_YEARS: TaxYearConfig[] = [
  {
    label: "2023/24",
    start: "2023-04-06",
    end: "2024-04-05",
    deadlines: { register: "5 Oct 2024", fileOnline: "31 Jan 2025", pay: "31 Jan 2025" },
  },
  {
    label: "2024/25",
    start: "2024-04-06",
    end: "2025-04-05",
    deadlines: { register: "5 Oct 2025", fileOnline: "31 Jan 2026", pay: "31 Jan 2026" },
  },
  {
    label: "2025/26",
    start: "2025-04-06",
    end: "2026-04-05",
    deadlines: { register: "5 Oct 2026", fileOnline: "31 Jan 2027", pay: "31 Jan 2027" },
  },
  {
    label: "2026/27",
    start: "2026-04-06",
    end: "2027-04-05",
    deadlines: { register: "5 Oct 2027", fileOnline: "31 Jan 2028", pay: "31 Jan 2028" },
  },
];

export function defaultTaxYear(): TaxYearConfig {
  const today = new Date().toISOString().slice(0, 10);
  const completed = TAX_YEARS.filter((y) => y.end < today);
  return completed.length > 0 ? completed[completed.length - 1] : TAX_YEARS[0];
}
